<div class="col-12 w-100 p-0">
    <select [formControl]="id" class="sell" SelectUi (change)="selectSubCat($event.target.value)">
        <option [value]="i.id" *ngFor="let i of shootSubCat.items;">{{i?.name || 'N/a'}}</option>
    </select>
    <img class="position-absolute imaag4" *ngIf="!shootSubCat?.isLoading"
        src="../../../../../assets/images/icon_drop down.png">
    <div class="position-absolute spinner" *ngIf="shootSubCat?.isLoading">
        <i class="fa fa-spinner fa-spin"></i>
    </div>
</div>